import { ColorFadingTextFX } from "./modules/ColorFadingTextFX";
import { OpacityFadingTextFX } from "./modules/OpacityFadingTextFX";
import { TransformTextFX } from "./modules/TransformFX";
import { TextFXModule } from "./TextFXModule";

export class TextFXModulesLibrary
{
  static readonly modules:TextFXModule[] =
  [
     new OpacityFadingTextFX(),
     new ColorFadingTextFX(),
     new TransformTextFX()
  ];
}